import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from './Icon';

const ITEMS = [
  { to: '/site',         label: 'Palpitar',  icon: <Icon.Whistle /> },
  { to: '/site/bets',    label: 'Histórico', icon: <Icon.Hist /> },
  { to: '/site/prizes',  label: 'Prêmios',   icon: <Icon.Gift /> },
  { to: '/site/faq',     label: 'Ajuda',     icon: <Icon.Info /> },
];

export function BottomNav() {
  return (
    <nav className="bottom-nav">
      {ITEMS.map((i) => (
        <NavLink key={i.to} to={i.to} exact className="bn-item" activeClassName="active">
          <span className="ico">{i.icon}</span>
          <span>{i.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
